module.exports = __webpack_public_path__ + "media/admin/components/worker-plugins/model-checkbox/company-image-06d90ef6177f20da55dd22e1d0697351.png";